import { useDispatch as reduxUseDispatch, useSelector as reduxUseSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { Dispatch, RootState } from './types/redux.types';

export const useDispatch: () => Dispatch = reduxUseDispatch;

export const useSelector: TypedUseSelectorHook<RootState> = reduxUseSelector;
